import { gql } from "graphql-request";

export const CREATE_SEASON_MUTATION = gql`
  mutation InsertSeason(
    $name: String!
    $startDate: DateTime
    $endDate: DateTime
    $maxGiveAmt: Int
    $minGiveAmt: Int
    $status: String
    $seasonAllowance: Int
  ) {
    insertseason(
      input: {
        name: $name
        startDate: $startDate
        endDate: $endDate
        maxGiveAmt: $maxGiveAmt
        minGiveAmt: $minGiveAmt
        status: $status
        seasonAllowance: $seasonAllowance
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Per-section "Save" on the Configure tab. Sends the full config snapshot
// every time so omitted variables never null-out existing fields.
export const UPDATE_SEASON_CONFIG_MUTATION = gql`
  mutation UpdateSeasonConfig(
    $itemId: String!
    $maxGiveAmt: Int
    $minGiveAmt: Int
    $seasonAllowance: Int
    $endDate: DateTime
  ) {
    updateseason(
      where: { ItemId: { eq: $itemId } }
      input: {
        maxGiveAmt: $maxGiveAmt
        minGiveAmt: $minGiveAmt
        seasonAllowance: $seasonAllowance
        endDate: $endDate
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_SEASON_MUTATION = gql`
  mutation UpdateSeason(
    $itemId: String!
    $status: String
    $endDate: DateTime
  ) {
    updateseason(
      where: { ItemId: { eq: $itemId } }
      input: {
        status: $status
        endDate: $endDate
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const GET_CURRENT_ACTIVE_SEASON_QUERY = gql`
  query GetCurrentActiveSeason($orgId: String!) {
    getseasons(
      where: {
        OrganizationId: { eq: $orgId }
        status: { eq: "active" }
      }
      order: []
      paging: {
        pageNo: 1
        pageSize: 1
      }
    ) {
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        CreatedBy
        Language
        LastUpdatedBy
        OrganizationId
        Tags
        name
        startDate
        endDate
        maxGiveAmt
        minGiveAmt
        seasonAllowance
        status
      }
      totalCount
      pageNo
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;


export const GET_ALL_SEASONS_QUERY = gql`
  query GetCurrentActiveSeason($orgId: String!) {
    getseasons(
      where: {
        OrganizationId: { eq: $orgId }
      }
      order: [{ field: "CreatedDate", direction: DESC }]
      paging: {}
    ) {
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        CreatedBy
        Language
        LastUpdatedBy
        OrganizationId
        Tags
        name
        startDate
        endDate
        maxGiveAmt
        minGiveAmt
        status
      }
      totalCount
      pageNo
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const CREATE_USER_STAR_BALANCE_MUTATION = gql`
  mutation InsertUserStarBalance(
    $userId: String!
    $seasonId: String!
    $seasonAllowance: Int!
    $userInfo: usersnapshotInput!
  ) {
    insertuserStarBalance(
      input: {
        userId: $userId
        seasonId: $seasonId
        seasonAllowance: $seasonAllowance
        userInfo: $userInfo
        starsRemaining: $seasonAllowance
      }
    ) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const GET_USER_STAR_BALANCE_QUERY = gql`
  query GetUserStarBalance($userId: String!, $seasonId: String!, $orgId: String!) {
    getuserStarBalances(
      where: {
        userId: { eq: $userId }
        seasonId: { eq: $seasonId }
        OrganizationId: { eq: $orgId }
      }
    ) {
      items {
        ItemId
        userId
        seasonId
        seasonAllowance
        starsRemaining
        userInfo {
          email
          profileImageUrl
          userId
          displayName
          firstName
          lastName
        }
        CreatedDate
        LastUpdatedDate
      }
      totalCount
    }
  }
`;


export const UPDATE_USER_STAR_BALANCE_MUTATION = gql`
  mutation UpdateUserStarBalance(
    $userId: String!,
    $seasonId: String!
    $starsRemaining: Int!
    $orgId: String!
  ) {
    updateuserStarBalance(
      where: {
        userId: { eq: $userId }
        seasonId: { eq: $seasonId }
        OrganizationId: { eq: $orgId }
      }
      input: {
        starsRemaining: $starsRemaining
      }
    ) {
      acknowledged
      itemId
    }
  }
`;

export const GET_SEASON_STAR_BALANCES_QUERY = gql`
  query GetSeasonStarBalances($seasonId: String!, $orgId: String!) {
    getuserStarBalances(
      where: {
        seasonId: { eq: $seasonId }
        OrganizationId: { eq: $orgId }
      }
    ) {
      items {
        ItemId
        userId
        seasonId
        seasonAllowance
        starsRemaining
        userInfo {
          email
          profileImageUrl
          userId
          displayName
        }
        CreatedDate
        LastUpdatedDate
      }
      totalCount
    }
  }
`;


/*
 * CR-B1-05: `recognitionAnswers` is an optional nested child schema field.
 * The `recognitionAnswersInput` type is auto-generated by Blocks Data Gateway
 * after running `madp run blocks-data-gateway`. Until the schema is synced,
 * the mutation still succeeds via the always-populated `message` field.
 * Schema-gap: requires `madp run blocks-data-gateway` to activate the field.
 */
export const CREATE_STAR_TRANSACTION_MUTATION = gql`
  mutation InsertStarTransaction(
    $seasonId: String!
    $senderId: String!
    $recipientId: String!
    $senderInfo: usersnapshotInput!
    $recipientInfo: usersnapshotInput!
    $amount: Int!
    $message: String
    $type: String!
    $recognitionAnswers: recognitionAnswersInput
  ) {
    insertstarTransaction(
      input: {
        seasonId: $seasonId
        senderId: $senderId
        recipientId: $recipientId
        senderInfo: $senderInfo
        recipientInfo: $recipientInfo
        amount: $amount
        message: $message
        type: $type
        recognitionAnswers: $recognitionAnswers
      }
    ) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const DELETE_STAR_TRANSACTION_MUTATION = gql`
  mutation DeleteStarTransaction($itemId: String!) {
    deletestarTransaction(where: { ItemId: { eq: $itemId } }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const GET_STAR_TRANSACTIONS_QUERY = gql`
  query GetStarTransactions(
    $seasonId: String
    $orgId: String!
    $pageNo: Int
    $pageSize: Int
  ) {
    getstarTransactions(
      where: {
        seasonId: { eq: $seasonId }
        OrganizationId: { eq: $orgId }
      }
      order: [{ field: "CreatedDate", direction: DESC }]
      paging: {
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        CreatedBy
        Language
        LastUpdatedBy
        OrganizationId
        Tags
        seasonId
        senderId
        senderInfo {
          displayName
          email 
        }
        recipientId
        recipientInfo {
          displayName
          email 
        }
        amount
        message
        recognitionAnswers {
          leadership
          reliability
          collaboration
          impact
        }
        type
      }
      totalCount
      pageNo
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;


export const GET_SEASON_STAR_TRANSACTIONS_QUERY = gql`
  query GetStarTransactions(
    $seasonId: String
    $orgId: String!
  ) {
    getstarTransactions(
      where: {
        seasonId: { eq: $seasonId }
        OrganizationId: { eq: $orgId }
      }
      order: [{ field: "CreatedDate", direction: DESC }]
    ) {
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        CreatedBy
        Language
        LastUpdatedBy
        OrganizationId
        Tags
        seasonId
        senderId
        senderInfo {
          displayName
          email
        }
        recipientId
        recipientInfo {
          displayName
          email
        }
        amount
        message
        recognitionAnswers {
          leadership
          reliability
          collaboration
          impact
        }
        type
      }
      totalCount
    }
  }
`;
